export const rentalObjectCategoryMap = {
  apartment: 'Leilighet',
  house: 'Enebolig',
  dorm: 'Hybel',
  'co-op': 'Rom i bofellesskap',
  'semi-detached': 'Tomannsbolig',
  'chained-house': 'Rekkehus',
  commercial: 'Næringseiendom',
  'garage-parking': 'Garasje / Parkering',
};

export const rentalObjectFacilityList = [
  {
    name: 'Aircondition',
    value: 'aircondition',
  },
  {
    name: 'Barnevennlig',
    value: 'barnevennlig',
  },
  {
    name: 'Garasje',
    value: 'garasje',
  },
  {
    name: 'Kabel-TV',
    value: 'kabel_tv',
  },
  {
    name: 'Parkett',
    value: 'parkett',
  },
  {
    name: 'Sentralt',
    value: 'sentralt',
  },
  {
    name: 'Turterreng',
    value: 'turterreng',
  },
  {
    name: 'Alarm',
    value: 'alarm',
  },
  {
    name: 'Moderne',
    value: 'moderne',
  },
  {
    name: 'Vaktmester',
    value: 'vaktmester',
  },
  {
    name: 'Bredbånd',
    value: 'bredbånd',
  },
  {
    name: 'Peis',
    value: 'peis',
  },
  {
    name: 'Heis',
    value: 'heis',
  },
  {
    name: 'Livløpsstandard',
    value: 'livløpsstandard',
  },
  {
    name: 'Utsikt',
    value: 'utsikt',
  },
  {
    name: 'Balkong',
    value: 'balkong',
  },
  {
    name: 'Fellesvaskeri',
    value: 'fellesvaskeri',
  },
  {
    name: 'Ingen gjenboere',
    value: 'ingen_gjenboere',
  },
  {
    name: 'Rolig',
    value: 'rolig',
  },
];
